<app-create-organisation (businessName)="CreateOrganisation($event)" [workspaceType]="workspaceType">
    <div title>
        Add a new {{workspaceType}} workspace
    </div>
    <div subTitle>
        Please enter your {{workspaceType}} workspace name in the field below
    </div>
</app-create-organisation>